export const RegExpAlphanumericGeneral = /^[a-zA-Z0-9-,.'&/#\x20]*$/;

export const RegExpAlphanumericName = /^[a-zA-Z0-9-_#\x20]*$/;

export const RegExNumeric = /^[0-9]*$/;

export const RegExAlphanumeric = /^[a-zA-Z0-9]*$/;

export const RegExAddress = /^[a-zA-Z0-9-,.'&/#\x20]*$/;

export const RegExBankInfo = /^[\w!@#$%&()\-+=?;:"'<>,.\x20]*$/;

export const RegExBankInfo2 = /^[\w!@#$%&()\-+=?;:"'<>,.\x20]*$|^N\/A$/;

export function containsInvalidUTF8(str: string): boolean {
  const regex =
    /[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]|\uFFFD/;
  return regex.test(str);
}
